import { Component, OnInit } from '@angular/core';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { DatePipe } from '@angular/common';
import { IbRequest } from '../ib-request';
import {IbResponse} from '../ib-response';
import { CallBackEndService } from '../call-back-end.service';
import * as jsPDF from 'jspdf';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
declare var getHexAscii: any;
@Component({
  selector: 'app-td-int-certificate',
  templateUrl: './td-int-certificate.component.html',
  styleUrls: ['./td-int-certificate.component.css'],
   providers: [DatePipe]
})
export class TdIntCertificateComponent implements OnInit {
  mytime:Date = new Date();
  currentYear:any= this.mytime.getUTCFullYear();
  currentDate:any= this.mytime.getUTCDate()+1;
  currentMonth:any= this.mytime.getUTCMonth() + 1;
  currentMonth1:any= this.mytime.getUTCMonth() + 7;
  fromyear=this.mytime.getUTCFullYear()-1;
  subBtnDisabled:boolean=false;
  fromDateNull : string ='';
  toDateNull : string='';
  messageForDate : string = '';
  messageForDate1 : string = '';
  messageForDate2 : string = '';
  fromGreaterCurrent : string ='';
   totalPrincipal:number=0.00;
   totalIntAmount:number=0.00;
   totalTDSAmount=0.00
   showError:string;
    fromDate : any ;
  toDate : any ;
    formatedDate : string='';
      TDAccountaddress : any =[];
       data : any =[];
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    editableDateField:false,
    disableUntil:{year: this.fromyear, month: this.currentMonth, day: this.currentDate-2},
  };
  myDatePickerOptions1: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    editableDateField:false,
    disableSince:{year: this.currentYear, month: this.currentMonth, day: this.currentDate},
  };
  constructor(private datePipe: DatePipe,private webService: CallBackEndService,private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
   
     this.formatedDate = this.datePipe.transform(new Date(), 'dd-MMM-yy');
  }
  validateToDate(event: IMyDateModel)
  {
   
     this.showError="";
    let date1=JSON.stringify(event.formatted);
 
    //console.log("date1.length----"+date1.length+"date2"+date2+"date1"+date1+"@@@@"+date3);
     if(event==null){
      this.toDateNull='no';
     }
     else if (date1==='""'||date1==='" "'||date1==='"  "' ||date1===undefined||date1===null) 
    {
    this.toDateNull='no';
     
   }else{
     this.toDateNull='';
   }
      
  }
  validateFromDate(event: IMyDateModel)
  {
   
     this.showError="";
    let date1=JSON.stringify(event.formatted);
 
    //console.log("date1.length----"+date1.length+"date2"+date2+"date1"+date1+"@@@@"+date3);
     if(event==null){
      this.fromDateNull='no';
     }
     else if (date1==='""'||date1==='" "'||date1==='"  "' ||date1===undefined||date1===null) 
    {
    this.fromDateNull='no';
     
   }else{
      this.fromDateNull='';
   }
      
  }
  
  dateconvert(monthNumber) { //1 = January
    var monthNames = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'June',
      'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ];
    return monthNames[monthNumber - 1];
  }
  DownLoadPDF()
  {
    
     if(this.fromDate==='' || this.fromDate===undefined || this.fromDate===null)
    {
      this.fromDateNull='no';
    }
    else if(this.toDate==='' || this.toDate===undefined || this.toDate===null)
    {
      this.toDateNull='no';
    }else
   {
         console.log("Date"+JSON.stringify(this.fromDate)+"FromDate--"+JSON.stringify(this.fromDate.date)+"To Date--"+JSON.stringify(this.toDate.date)+"Current Date--"+this.formatedDate); 

    var date1 = (this.fromDate.date.day + "-" + this.dateconvert(this.fromDate.date.month) + "-" + this.fromDate.date.year).split("-");
    var date2 = (this.toDate.date.day + "-" + this.dateconvert(this.toDate.date.month) + "-" + this.toDate.date.year).split("-");
    var date3 = this.formatedDate.split("-");
    var d1 = Date.parse(date1[0] + "-" + date1[1] + "-" + date1[2]);
    var d2 = Date.parse(date2[0] + "-" + date2[1] + "-" + date2[2]);
    var d3 = Date.parse(date3[0] + "-" + date3[1] + "-" + date3[2]);
    console.log(date1[0] + "-" + date1[1] + "-" + date1[2])
    console.log(date2[0] + "-" + date2[1] + "-" + date2[2])
    console.log(date3[0] + "-" + date3[1] + "-" + date3[2])
       var yearNumber1 = Number(date1[2] || 0);
    var yearNumber2 = Number(date2[2] || 0);
    var yearNumber3 = Number(date3[2] || 0);
    var monthNumber1 = Number(this.fromDate.date.month || 0);
    var monthNumber2 = Number(this.toDate.date.month || 0);
       console.log("@@@@@@@@@@"+yearNumber1+yearNumber2 +monthNumber1+monthNumber2+ yearNumber2+yearNumber1);

   // var monthNumber3 = Number(monthInNo3 || 0);
    
   if (d1 > d2) {
     this.messageForDate = 'no';
     // this.subBtnDisabled = false;
     // this.spinnerService.hide();
    } else if (d2 > d3) {
      this.messageForDate1 = 'no';
     // this.subBtnDisabled = false;
    // this.spinnerService.hide();
    } else if (d1 > d3) {
      this.fromGreaterCurrent = 'no';
     // this.subBtnDisabled = false;
     // this.spinnerService.hide();
    } else if((yearNumber1<yearNumber2 && (monthNumber1-monthNumber2)<0) || yearNumber2-yearNumber1>1) {
      this.messageForDate2='no';
    }else
    {
		this.spinnerService.show();
         const request: IbRequest = new IbRequest();
        let response: IbResponse = null;
        this.showError='';
            request.param2 =sessionStorage.getItem('custNo');
            request.param3 =this.fromDate.formatted; //this.fromDate.date.day + "-" + this.fromDate.date.month+ "-" + this.fromDate.date.year;
	  request.param4 =this.toDate.formatted ;//this.toDate.date.day + "-" + this.toDate.date.month + "-" + this.toDate.date.year;
	  request.param5=sessionStorage.getItem('storedUserName');
       request.param1 = getHexAscii("",sessionStorage.getItem('custNo')+ request.param3+ request.param4+ request.param5);
          this.webService.getResponse(request, 'getTDInterestCert').subscribe((data: IbResponse) => {
			 this.spinnerService.hide();
            if (data.status === 'S200') { 
              
           this.TDAccountaddress=data.param5;
           this.data=data.param6;
           if(this.data==null || this.data==undefined || this.data.length==0){
            this.showError='Record Not found';
           }else{
            this.downloadPdf();
           }
           // this.downloadPdf();
            }
            // else  if (data.status!=null && data.param1!=null && data.param1!=='') 
            // {

            //   this.showError=data.param1;
            // }
            else{
              if(data.param1==null || data.param1==undefined || data.param1===''){
                this.showError='Something Went Wrong.Please Try Again Later.';
              }else{
                this.showError=data.param1;
              }
             
            }
          });
    }
  }
}

  removeFromDateMessages()
  {
   this.messageForDate = '';
    this.messageForDate1 = '';
     this.fromGreaterCurrent = '';
      this.messageForDate2='';
  }
   removeToDateMessages()
  {
     this.messageForDate = '';
     this.messageForDate1 = '';
    this.messageForDate2='';
      this.fromGreaterCurrent = '';
  }
   downloadPdf() {
 
var pdf = new jsPDF();
 var a = Number(20 || 0);
        var b = Number(8 || 0); 
        var c = Number(30 || 0);
        var d = Number(20 || 0);
        var e = Number(193 || 0);
        var f = Number(35 || 0);
        var g = Number(8 || 0);
        var h = Number(2 || 0); 
        var i = Number(1 || 0);
       var s = Number(5 || 0);
   pdf.setFontSize(12);
  // pdf.text(h+2, a, ''); pdf.text(h+108, a, '');a=a+b; d=d+b; //blank line
    pdf.text(10, a,""); a=a+g; d=d+g;  //blank line
    pdf.text(10, a,""); a=a+g; d=d+g;

    pdf.text(56, a, 'TD Interest Certificate '); a=a+g; d=d+g;
    pdf.setFontSize(10);
    let today=new Date();
    let fromDate=this.fromDate.date.day + "-" +this.dateconvert( this.fromDate.date.month)+ "-" + this.fromDate.date.year;
    let toDate= this.toDate.date.day + "-" + this.dateconvert(this.toDate.date.month) + "-" + this.toDate.date.year;
    pdf.text(h+165, a, 'Date : '+this.currentDate+"-"+this.currentMonth+"-"+this.currentYear); a=a+g; d=d+g;
    pdf.text(10, a,"Sir/Madam,"); a=a+g; d=d+g;
    pdf.text(20, a," This is to certify that the following amount have been accured and/or have been paid on the undermentioned "); a=a+g; d=d+g
    pdf.text(20, a,"Term Deposits during period from "+fromDate+" to "+toDate+"of "); a=a+b; d=d+b;
   // pdf.text(20, a,"Customer Number: "+this.TDAccountaddress.NameTitle+this.TDAccountaddress.CustName); a=a+g; d=d+g
    pdf.text(20, a,"Customer Name: "+this.TDAccountaddress.NameTitle+this.TDAccountaddress.CustName); a=a+g; d=d+g
    pdf.text(20, a,"Address: ");pdf.text(35,a, this.TDAccountaddress.add1==null ? '' : this.TDAccountaddress.add1); a=a+b; d=d+b;
                               pdf.text(35, a-2,this.TDAccountaddress.add2==null ? '' : this.TDAccountaddress.add2);a=a+b; d=d+b;
                               pdf.text(35, a-2,this.TDAccountaddress.add3==null ? '' : this.TDAccountaddress.add3);a=a+b; d=d+b;
                               pdf.text(35, a-2,this.TDAccountaddress.city==null ? '' : this.TDAccountaddress.city);a=a+b; d=d+b;
                               pdf.text(35, a-2,this.TDAccountaddress.pinCd==null ? '' : this.TDAccountaddress.pinCd);a=a+b; d=d+b;
  // if(this.TDAccountaddress.add3!=null && this.TDAccountaddress.add3!=undefined && this.TDAccountaddress.add3!==''){
  //      pdf.text(25, a,this.TDAccountaddress.add3);a=a+b; d=d+b;
  //      }
      
  // pdf.text(35, a+54,this.TDAccountaddress.area);a=a+b; d=d+b;
                              
                               c=d+5;
   
     pdf.line(h+5, a-3, e, a-3);
     let srno:number=1;
        for(const [key, value] of Object.entries(this.data)) {           
            if(i===1){
            pdf.setFontType("bolditalic");
            pdf.setTextColor(0, 0, 255);
              h=h+5;
             
             pdf.text(h, a, 'SR. No.');
            pdf.text(h+18, a, 'Branch Code');
             pdf.text(h+43, a, 'Account No.');
             pdf.text(h+83, a, 'Principal Amount');
             pdf.text(h+118, a, 'Interest Rate');
             pdf.text(h+143, a, 'Interest');
             pdf.text(h+158, a, 'TDS');
             pdf.text(h+170, a, 'Status');

            pdf.setTextColor(75,75,75);
            }
            i++;
             
            a=a+s;
            c=c+5;
      
            pdf.line(h, a-3, e, a-3);   
      
       

           if((i-1)%f===0){
            pdf.setFontType("bolditalic");
            pdf.setTextColor(0, 0, 255);
              
            // pdf.text(h, a, 'SR. No.');
            // pdf.text(h+8, a, 'Date');
            // pdf.text(h+38, a, 'Particulars');
            // pdf.text(h+93, a, 'Dr Amount');
            // pdf.text(h+108, a, 'Cr Amount');
            // pdf.text(h+123, a, 'Total Amount');
            // pdf.text(h+138, a, 'DR/CR');
               pdf.text(h, a, 'SR. No.');
            pdf.text(h+18, a, 'Branch Code');
             pdf.text(h+43, a, 'Account No.');
             pdf.text(h+83, a, 'Principal Amount');
             pdf.text(h+118, a, 'Interest Rate');
             pdf.text(h+143, a, 'Interest');
             pdf.text(h+158, a, 'TDS');
             pdf.text(h+170, a, 'Status');


          pdf.setTextColor(75,75,75);
            a=a+s;
            c=c+5;
            i++;
            pdf.line(h, a-3, e, a-3); 
            
                 pdf.text(h+3, a, srno+'');
            pdf.text(h+19, a, value.BrCode+'');
            pdf.text(h+44, a, value.AccNo+'');
       
            pdf.text(h+84, a, value.PrincAmt+'');
            pdf.text(h+119, a,value.intRate);
              pdf.text(h+144, a,value.intAmt);
             pdf.text(h+159, a,value.TDSAmt);
              pdf.text(h+171, a,value.status);
            
        }else{
                pdf.text(h+3, a,  srno+'');
            pdf.text(h+19, a,value.BrCode+'');
            pdf.text(h+44, a, value.AccNo+'');
        
            pdf.text(h+84, a,value.PrincAmt);
             pdf.text(h+119, a,value.intRate);
             pdf.text(h+144, a,value.intAmt);
             pdf.text(h+159, a,value.TDSAmt);
              pdf.text(h+171, a,value.status);
        }
        //totalClosingAmount = value.balance;
   if(value.status==='Open')
   {
     this.totalPrincipal=parseFloat(this.totalPrincipal+"")+parseFloat(value.PrincAmt+"");
   }
   this.totalIntAmount=this.totalIntAmount+Number(value.intAmt);
   this.totalTDSAmount=this.totalTDSAmount+Number(value.TDSAmt);

        if(i%f===0){
      
          pdf.line(h, d-3, h, c-3);
          pdf.line(h+18, d-3, h+18, c-3);
          pdf.line(h+42, d-3, h+42, c-3);
          pdf.line(h+83, d-3, h+83, c-3);
          pdf.line(h+118, d-3, h+118, c-3);
          pdf.line(h+143, d-3, h+143, c-3);
          pdf.line(h+158, d-3, h+158, c-3);
          pdf.line(h+170, d-3, h+170, c-3);
          pdf.line(h+186, d-3, h+186, c-3);
    
          
          pdf.line(h, a+2, e, a+2);
          
          pdf.addPage();
          a=20;
          d=25;
          c=25;
        }
        srno++;
        }
    
    pdf.line(h, d-3, h, c-3);
    pdf.line(h+18, d-3, h+18, c-3);
    pdf.line(h+42, d-3, h+42, c-3);
    pdf.line(h+83, d-3, h+83, c-3);
    pdf.line(h+118, d-3, h+118, c-3);
    pdf.line(h+143, d-3, h+143, c-3);
    pdf.line(h+158, d-3, h+158, c-3);
    pdf.line(h+170, d-3, h+170, c-3);
    pdf.line(h+186, d-3, h+186, c-3);
    pdf.line(h, a-3, e, a-3); 
    

     pdf.line(h, c+2, h,a-6);
       pdf.line(h+83, c+2, h+83, a-6); 
    pdf.line(h+118,  c+2, h+118, a-6);
    pdf.line(h+143, c+2, h+143,a-6);
    pdf.line(h+158,  c+2, h+158, a-6);
    pdf.line(h+170, c+2, h+170, a-6);
    pdf.line(h+186,  c+2, h+186, a-6);

    a=a+s;
    pdf.text(h, a, 'Total For :INR');
    pdf.text(h+84, a, this.totalPrincipal+'');
    pdf.text(h+144, a, this.totalIntAmount+'');
    pdf.text(h+159, a, this.totalTDSAmount+'');
    pdf.text(h+138, a, '');
    pdf.line(h, a-3, e, a-3); 
      
     pdf.line(h, a, h, a);
 
  

    // pdf.text(h+40, a+20, 'Note: Closed Recipts are not considered under Total Principal Amount');
    
    // a=a+s;
    // pdf.text(h, a, 'No. of recipts');
    // pdf.text(h+123, a,'');
    // pdf.line(h, a-3, e, a-3); 
    
        

    a=a+s;
    pdf.line(h, a-3, e, a-3); 
   var img = new Image;
    img.onload = function() {
      pdf.setPage(1);
        pdf.addImage(this, 2, 5, 100, 17);
        pdf.save("TdIntCert"+".pdf");
    };
    img.crossOrigin = "";
    img.src = 'assets/img/LogoWithName.png';

}
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/td-int-certificate/td-int-certificate.component.ts